import React from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useMediaQuery from '@mui/material/useMediaQuery';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Theme} from './Theme';
import {Item,Owner} from './Inc';
import useStyles from './Styles';
import Ajax from './Ajax';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTruck } from '@fortawesome/free-solid-svg-icons';

interface Props {
	isOpen:boolean,
    owner:Owner,
    sheetId:number,
    items:Item[],
    values:number[],
    close(): void,
}

const LetterFree = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    library.add(faTruck);

    let sum = 0;
    for( let i=0 ; i<props.items.length ; i++ ){
        sum += props.items[i].price * props.values[i];
    }

	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}	
		>
			<DialogTitle color='primary'>手書きの納品書</DialogTitle>
			<DialogContent dividers>
				<Paper style={{padding:"1em",paddingBottom:"2em",textAlign:"center",marginBottom:"2em"}} className={classes.primary}>
					<div style={{fontSize:"90%"}}>納品受付番号</div>
					<div style={{fontSize:"200%"}}>{props.sheetId}</div>
				</Paper>
				<div className={classes.confirmGuide}>
					手書きの納品書に「納品受付番号」を書き添えて、商品と一緒にお送りください。<br/>
					<br/>
					<ul className={classes.hintUl}>
						<li className={classes.hintLi}>※納品書には、<b>以下の表の内容（商品名、ＩＤ、個数、価格）</b>と<b>ご連絡先（お客様の氏名、住所、電話番号）</b>を必ず記載してください。</li>
						<li className={classes.hintLi}>※商品の個数や内容を変更する場合は納品書を作り直してください。※納品受付番号が変わります。</li>
						<li className={classes.hintLi}>※各商品にはＩＤが分かるような工夫が必要です。詳しくはヘルプ！をご覧ください。</li>
					</ul>
				</div>

				<Table>
					<TableHead>
						<TableRow>
							<TableCell className={classes.tableHeadNowrap}>ID/商品名</TableCell>
							<TableCell className={classes.tableHeadNowrap}>個数</TableCell>
							<TableCell className={classes.tableHeadNowrap}>価格</TableCell>
							<TableCell className={classes.tableHeadNowrap}>小計</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
				{props.items.map( (item:any,index:number)=>{
					const key = "item"+index;
					return (
						<TableRow key={key}>
							<TableCell className={classes.tableCellDense}>
								ID:{item.item_id}<br/>
								{item.item_name}<br/>
							</TableCell>
							<TableCell className={classes.tableCellNowrap} align="right">{props.values[index]}{item.unit}</TableCell>
							<TableCell className={classes.tableCellNowrap} align="right">{item.price}円</TableCell>
							<TableCell className={classes.tableCellNowrap} align="right">{item.price*props.values[index]}円</TableCell>
						</TableRow>
					);
				})}
						<TableRow>
							<TableCell className={classes.tableCellNowrap}>合計金額（消費税込）</TableCell>
							<TableCell className={classes.tableCellNowrap}></TableCell>
							<TableCell className={classes.tableCellNowrap}></TableCell>
							<TableCell className={classes.tableCellNowrap} align="right">{sum}円</TableCell>
						</TableRow>
					</TableBody>
				</Table>

				<div style={{fontSize:"90%",margin:"1em 0",padding:"1em",border:"1px solid silver"}}>
					<div className={classes.primary}><FontAwesomeIcon icon="truck"/> 商品の送り先</div>
					〒181-0001<br/>
					東京都三鷹市井の頭4-26-7<br/>
					架空ストア<br/>
					TEL 0422-24-9529<br/>
				</div>
				<div style={{fontSize:"90%",padding:"1em",border:"1px solid silver",marginBottom:'1em'}}>
						<div className={classes.primary}><FontAwesomeIcon icon="question-circle"/> 追跡番号を登録しましょう</div>
						<div>荷物の発送が済みましたら、納品の履歴から荷物の追跡番号をお知らせしていただくと手続きがスムーズになります</div>
					</div>				
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default LetterFree;
